import * as React from "react";

interface Props {
    shopUrl: string
}

// A list of shops that have been opted out of the "Powered by Stages" text.
const optedOutShopUrls: string[] = [
    "dotodone.myshopify.com"
];

export function PoweredByFooter(props: Props): JSX.Element {
    const style = { marginBottom: "0px" };

    if (optedOutShopUrls.some(url => url === props.shopUrl)) {
        return <React.Fragment />;
    }

    return (
        <p style={style}>
            <small>
                {"Powered by "}
                <a key={"powered-by"} href="https://getstages.com" target="_blank">
                    {"Stages"}
                </a>
            </small>
        </p>
    );

}
